/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { EditNewCampione } from "./components/EditNewCampione";
import { Chip, Avatar } from "@material-ui/core";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { Skeleton } from "@material-ui/lab";
import * as PropTypes from "prop-types";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'

import {
  SortingState,
  IntegratedSorting,
  PagingState,
  IntegratedPaging,
  FilteringState,
  IntegratedFiltering,
  DataTypeProvider,
} from "@devexpress/dx-react-grid";
import { Grid, Table, TableHeaderRow, PagingPanel, TableFilterRow } from "@devexpress/dx-react-grid-bootstrap4";
import "@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css";
import SVG from "react-inlinesvg";
import { Card, Tooltip, OverlayTrigger, Button, Modal } from "react-bootstrap";
import moment from "moment-timezone";
import { useHistory } from "react-router-dom";

import { roles, roleOptionsForSelect, icons } from "../../config/config";
import * as apiCampioni from "../../api/campioni";
import * as apiTarget from "../../api/target";
import { capitalize } from "../../Helpers";

// Useful sub-components
const TableComponent = ({ ...restProps }) => (
  <Table.Table {...restProps} className="table table-hover table-head-custom table-vertical-center overflow-hidden" />
);

const CustomHeaderCell = ({ column, children }) => (
  <TableHeaderRow.Cell column={column} >
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        fontWeight: "bold",
      }}
    >
      {children}
    </div>
  </TableHeaderRow.Cell>
);

const RowComponent = ({ row, ...restProps }) => {
  let backgroundColor = ""; // Default

  if (parseInt(row.available, 10) === 0) {
    backgroundColor = "rgba(255, 50, 50, 0.05)"; // Rosso grigio
  } else if (parseInt(row.available, 10) === 1) {
    backgroundColor = "rgba(204, 255, 204, 0.4)"; // Rosso grigio
  }

  return (
    <Table.Row
      {...restProps}
      style={{
        backgroundColor,
        cursor: "pointer",
      }}
    />
  );
};

const TabellaCampioniToolbar = ({ addCallback, ...props }) => {
  return (
    <div {...props}>
      <Button onClick={addCallback} className="float-right">
        Aggiungi nuovo campione
      </Button>
    </div>
  );
};

const FilterCell = (props) => {
  const { column } = props;
  if (column.name === "actions") {
    const ActionsFilterCell = ({ filter, onFilter }) => (
      <th style={{ fontWeight: "normal" }}>
        <input disabled style={{ visibility: "hidden" }} />
      </th>
    );
    ActionsFilterCell.propTypes = {
      filter: PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      }),
      onFilter: PropTypes.func.isRequired,
    };
    ActionsFilterCell.defaultProps = {
      filter: null,
    };
    return <ActionsFilterCell {...props} />;
  }
  return <TableFilterRow.Cell {...props} />;
};
FilterCell.propTypes = {
  column: PropTypes.shape({ name: PropTypes.string }).isRequired,
};

const TargetFormattedColumn = (props) => {
  const { targets = [] } = props;
  return (
    <DataTypeProvider
      formatterComponent={({ value }) => {
        const t = targets.find((tg) => tg.id === value);
        return t ? `${t.nome} (${t.id})` : "";
      }}
      {...props}
    />
  );
};

const DateFormattedColumn = (props) => (
  <DataTypeProvider formatterComponent={({ value }) => moment(value).format("DD/MM/YYYY")} {...props} />
);

const QtaFormattedColumn = (props) => (
  <DataTypeProvider formatterComponent={({ value }) => <div style={{ textAlign: "center" }}>{value}</div>} {...props} />
);

const SkuFormattedColumn = (props) => (
  <DataTypeProvider formatterComponent={({ value }) => <div style={{ textAlign: "center" }}>{value}</div>} {...props} />
);

const QuantityFormattedColumn = (props) => (
  <DataTypeProvider formatterComponent={({ value }) => <div style={{ textAlign: "center" }}>{value}</div>} {...props} />
);

const PriceFormattedColumn = (props) => (
  <DataTypeProvider
    formatterComponent={({ value }) => (
      <div style={{ textAlign: "center" }}>{(typeof value == "string" ? parseFloat(value) : value).toFixed(2)}€</div>
    )}
    {...props}
  />
);
const AvailabilityFormattedColumn = (props) => (
  <DataTypeProvider
    formatterComponent={({ value }) => {
      const isAvailable = [1, "1", true].includes(value);
      return (
        <>
          {isAvailable ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <Avatar style={{ width: 25, height: 25, backgroundColor: "var(--success)", textAlign: "center" }}>
                <span className="svg-icon svg-icon-md svg-icon-white">
                  <SVG src={toAbsoluteUrl(icons.ok)} />
                </span>
                {/* <i className="ki ki-plus icon-white"></i> */}
              </Avatar>
            </div>
          ) : null}
        </>
      );
    }}
    {...props}
  />
);

const ImageWithLightbox = ({ row, value }) => {
  const [isOpen, setIsOpen] = useState(false);
  const imageUrl = toAbsoluteUrl(row.image, row.division);
  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ alignSelf: 'center', marginRight: '5px' }}>
          {value}
        </div>
        <div
          onClick={() => setIsOpen(true)}
          style={{
            display: 'inline-block',
            borderRadius: '8px',
            height: '5vh',
            backgroundColor: 'white',
            textAlign: 'center',
            overflow: 'hidden',
            alignSelf: 'center',
            minWidth: '5vh',
            maxWidth: '5vh',
            minHeight: '5vh',
          }}
        >
          <img src={imageUrl} style={{ width:'100%', height: 'auto' }} alt="" />
        </div>
      </div>

      {isOpen && (
        <Lightbox
          mainSrc={imageUrl}
          onCloseRequest={() => setIsOpen(false)}
        />
      )}
    </>
  );
};

const NameFormattedColumn = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <DataTypeProvider
      formatterComponent={({ row, value }) =>
        (row.image !== "" && row.image !== "0")
          ? <ImageWithLightbox row={row} value={value} />
          : <>{value}</>          
      }
      {...props}
    />
  );
}

const ActionsColumn = ({
  isAdmin,
  isDeveloper,
  isMagazziniere,
  isGrafico,
  editCallback,
  availableCallback,
  notAvailableCallback,
  deleteCallback,
}) => (
  <DataTypeProvider
    for={["actions"]}
    formatterComponent={({ value }) => (
      <>
        {isAdmin || isDeveloper || isMagazziniere || isGrafico ? (
          <OverlayTrigger overlay={<Tooltip id="products-edit-tooltip">Modifica</Tooltip>}>
            {/*eslint-disable-next-line*/}
            <a className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3" onClick={() => editCallback(value.id)}>
              <span className="svg-icon svg-icon-md svg-icon-primary">
                <SVG src={toAbsoluteUrl(icons.edit)} />
              </span>
            </a>
          </OverlayTrigger>
        ) : null}
        <OverlayTrigger
          overlay={
            <Tooltip id="products-available-tooltip">
              {value.available ? "Imposta come non disponibile" : "Imposta come disponibile"}
            </Tooltip>
          }
        >
          {/*eslint-disable-next-line*/}
          <a
            className={
              "btn btn-icon btn-light btn-sm mr-3 " + (value.available ? "btn-hover-danger" : "btn-hover-success")
            }
            onClick={value.available ? () => notAvailableCallback(value.id) : () => availableCallback(value.id)}
          >
            <span className={"svg-icon svg-icon-md " + (value.available ? "svg-icon-danger" : "svg-icon-success")}>
              <SVG src={value.available ? toAbsoluteUrl(icons.close) : toAbsoluteUrl(icons.ok)} />
            </span>
          </a>
        </OverlayTrigger>
        {isAdmin || isDeveloper || isMagazziniere || isGrafico ? (
          <OverlayTrigger overlay={<Tooltip id="products-delete-tooltip">Elimina</Tooltip>}>
            {/*eslint-disable-next-line*/}
            <a className="btn btn-icon btn-light btn-hover-danger btn-sm" onClick={() => deleteCallback(value.id)}>
              <span className="svg-icon svg-icon-md svg-icon-danger">
                <SVG src={toAbsoluteUrl(icons.delete)} />
              </span>
            </a>
          </OverlayTrigger>
        ) : null}
      </>
    )}
  />
);

const AziendaColumn = (props) => {
  let value = props.value;
  var vd = value.includes("Valderma");
  var rp = value.includes("Roypet");
  var rd = value.includes("Roydermal");

  return (
    <div className="pl-3">
      {vd ? (
        <Chip
          style={{ borderColor: "#003366", color: "#003366" }}
          variant="outlined"
          avatar={
            <Avatar
              alt="VD"
              src={toAbsoluteUrl("/media/logos/valderma-logo-bianco.png")}
              style={{ backgroundColor: "#003366", color: "#FFFFFF" }}
            >
              VD
            </Avatar>
          }
          label="Valderma"
        />
      ) : null}
      {rp ? (
        <Chip
          style={{ borderColor: "#313d85", color: "#313d85" }}
          variant="outlined"
          avatar={
            <Avatar alt="RP" src={toAbsoluteUrl("/media/products/roypet.png")}>
              RP
            </Avatar>
          }
          label="Roypet"
        />
      ) : null}
      {rd ? (
        <Chip
          style={{ borderColor: "#C92020", color: "#C92020" }}
          variant="outlined"
          avatar={
            <Avatar alt="RD" src={toAbsoluteUrl("/media/products/roydermal.png")}>
              RD
            </Avatar>
          }
          label="Roydermal"
        />
      ) : null}
    </div>
  );
};

export const AziendaFormattedColumn = (props) => <DataTypeProvider formatterComponent={AziendaColumn} {...props} />;

const DeleteModal = ({ name, show, hideCallback, deleteCallback }) => (
  <Modal show={show} onHide={hideCallback} className="card-custom gutter-b">
    <Modal.Header className="border-0 py-5 row">
      <Modal.Title>
        <h3 className="font-weight-bolder text-dark">Elimina campione</h3>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body className="p-4">Sei sicuro di voler eliminare definitivamente "{name}"</Modal.Body>
    <Modal.Footer className="border-0 py-5 row">
      <Button onClick={deleteCallback} variant="danger" className="float-right">
        Elimina
      </Button>
      <Button onClick={hideCallback} variant="secondary" className="float-right">
        Annulla
      </Button>
    </Modal.Footer>
  </Modal>
);

// Columns definition
const columns = [
  { name: "sku", title: "SKU" },
  { name: "name", title: "Nome",
    getCellValue: (row) => capitalize(row.name.toLowerCase()).trim() }, // Valore usato per l'ordinamento
  { name: "qta", title: "qta" },
  { name: "quantity", title: "Pz/Cart." },
  { name: "price", title: "Prezzo" },
  { name: "available", title: "Disponibilità" },
  {
    name: "division",
    title: "Azienda",
    getCellValue: (row) =>
      parseInt(row.division, 10) == 11 ? ["Valderma"] : row.division == 1 ? ["Roypet"] : ["Roydermal"] || [],
  },
  //{ name: "target", title: "Target" }, // <--- aggiunta qui
  // { name: "dateCreated", title: "Creato il" },
  { name: "actions", title: "Azioni" },
];

const columnExtensions = [
  { columnName: "sku", width: "80" },
  { columnName: "name", wordWrapEnabled: true },
  { columnName: "qta", width: "80" },
  { columnName: "quantity", width: "120", align: "center" },
  // { columnName: "dateCreated", width: "150", wordWrapEnabled: true },
  { columnName: "price", width: "100", align: "center" },
  { columnName: "available", width: "100", align: "center" },
  { columnName: "division", width: "180" },
  { columnName: "actions", width: "180" },
];

// Messages
const tableMessages = {
  noData: "Nessun campione inserito",
};
const filterRowMessages = {
  filterPlaceholder: "Filtra...",
};
const pagingPanelMessages = {
  showAll: "Tutte",
  rowsPerPage: "Righe per pagina",
  info: "Da {from} a {to} ({count} richieste)",
};

// Paging and sorting
const pageSizes = [10, 20, 30, 0];
const initialPageSize = 10;
const initialSorting = [{ columnName: "id", direction: "desc" }];

export const TabellaCampioni = () => {
  // table data
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [_internalUpdateCount, _setInternalUpdateCount] = useState(0);
  const [targets, setTargets] = useState([]);

  // User redux
  const user = useSelector((state) => state.auth.user, shallowEqual);
  const role = parseInt(user.idRole);

  const updateFromServer = () => {
    setLoading(true);
    apiCampioni
      .getAll(user.authToken)
      // row.actions is passed to the btn constructors which passes it to the callbacks
      .then((data) =>
        setRows(
          data.map((row) => ({
            ...row,
            actions: { id: row.id, available: row.available },
            target: row.target_id, // aggiungi questa riga
          }))
        )
      )
      .then(() => setLoading(false));
  };
  const triggerServerUpdate = () => _setInternalUpdateCount(_internalUpdateCount + 1);
  useEffect(() => {
    updateFromServer();
  }, [_internalUpdateCount]);

  useEffect(() => {
    apiTarget
      .getTargets(user.authToken)
      .then(setTargets)
      .catch(async (err) => {
        // Prova a recuperare i dati dal messaggio di errore se è un JSON valido
        if (err && err.message && err.message.includes("[")) {
          try {
            const jsonStart = err.message.indexOf("[");
            const jsonString = err.message.substring(jsonStart);
            const data = JSON.parse(jsonString);
            setTargets(data);
          } catch (e) {
            setTargets([]);
          }
        } else {
          setTargets([]);
        }
      });
  }, []);

  // edit page
  const [showEditPage, setShowEditPage] = useState(false);
  const [campioneForEdit, setCampioneForEdit] = useState(false);
  // delete modal
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // bind history to views to allow deep-linking
  const { location, push } = useHistory();
  useEffect(() => {
    if (!loading) {
      if (location.hash && location.hash === "#/new") {
        setCampioneForEdit(false);
        setShowEditPage(true);
        setShowDeleteModal(false);
      } else if (location.hash && location.hash.startsWith("#/delete/")) {
        const idForEdit = parseInt(location.hash.substring(9));
        if (!isNaN(idForEdit)) {
          const row = rows.find((r) => r.id == idForEdit);
          if (row !== undefined) {
            setCampioneForEdit(row);
            setShowEditPage(false);
            setShowDeleteModal(true);
          }
        }
      } else if (location.hash && location.hash.startsWith("#/edit/")) {
        const idForEdit = parseInt(location.hash.substring(7));
        if (!isNaN(idForEdit)) {
          const row = rows.find((r) => r.id == idForEdit);
          if (row !== undefined) {
            setCampioneForEdit(row);
            setShowEditPage(true);
            setShowDeleteModal(false);
          }
        }
      } else {
        setCampioneForEdit(false);
        setShowEditPage(false);
        setShowDeleteModal(false);
      }
    }
    /*eslint-disable-next-line*/
  }, [location.hash, loading]);

  // paging and sorting
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(initialPageSize);
  const [sorting, setSorting] = useState(initialSorting);

  if (!showEditPage) {
    return (
      <>
        <DeleteModal
          show={showDeleteModal}
          name={campioneForEdit.name}
          hideCallback={() => {
            // setShowDeleteModal(false);
            push("#/");
          }}
          deleteCallback={() => {
            apiCampioni.remove(user.authToken, campioneForEdit.id).then(() => {
              // setShowDeleteModal(false);
              push("#/");
              triggerServerUpdate();
            });
          }}
        />
        <Card className="card-custom gutter-b">
          <Card.Header className="border-0 py-5 row">
            <Card.Title className="float-left col-auto">
              <h3 className="font-weight-bolder text-dark">Campioni</h3>
            </Card.Title>
            <TabellaCampioniToolbar
              addCallback={() => {
                // setCampioneForEdit(false);
                // setShowEditPage(true);
                push("#/new");
              }}
              className="float-right col-auto"
            />
          </Card.Header>
          <Card.Body className="pt-0">
            {!loading ? (
              <Grid rows={rows} columns={columns}>
                <ActionsColumn
                  isAdmin={role === roles.admin || role === roles.gestore}
                  isDeveloper={role === roles.developer}
                  isMagazziniere={role === roles.magazziniere}
                  isGrafico={role === roles.grafico}
                  editCallback={(id) => {
                    // setCampioneForEdit(rows.find((r) => r.id === id));
                    // setShowEditPage(true);
                    push(`#/edit/${id}`);
                  }}
                  availableCallback={(id) => {
                    apiCampioni.setAvailability(user.authToken, id, 1).then(triggerServerUpdate);
                  }}
                  notAvailableCallback={(id) => {
                    apiCampioni.setAvailability(user.authToken, id, 0).then(triggerServerUpdate);
                  }}
                  deleteCallback={(id) => {
                    // setCampioneForEdit(rows.find((r) => r.id === id));
                    // setShowDeleteModal(true);
                    push(`#/delete/${id}`);
                  }}
                />
                <NameFormattedColumn for={["name"]} />
                <QtaFormattedColumn for={["qta"]} />
                <SkuFormattedColumn for={["sku"]} />
                <QuantityFormattedColumn for={["quantity"]} />
                {/* <DateFormattedColumn for={["dateCreated"]} /> */}
                <PriceFormattedColumn for={["price"]} />
                <AvailabilityFormattedColumn for={["available"]} />
                <AziendaFormattedColumn for={["division"]} />
                <TargetFormattedColumn for={["target"]} targets={targets} />
                <FilteringState />
                <IntegratedFiltering />
                <PagingState
                  currentPage={currentPage}
                  onCurrentPageChange={setCurrentPage}
                  pageSize={pageSize}
                  onPageSizeChange={setPageSize}
                />
                <IntegratedPaging />
                <SortingState sorting={sorting} onSortingChange={setSorting} />
                <IntegratedSorting />
                <Table
                  messages={tableMessages}
                  columnExtensions={columnExtensions}
                  tableComponent={TableComponent}
                  rowComponent={RowComponent}
                />
                <TableHeaderRow cellComponent={CustomHeaderCell} showSortingControls />
                <TableFilterRow messages={filterRowMessages} cellComponent={FilterCell} />
                <PagingPanel messages={pagingPanelMessages} pageSizes={pageSizes} />
              </Grid>
            ) : (
              <div>
                <Skeleton variant="text" />
                <Skeleton variant="text" />
                <Skeleton variant="text" />
                <Skeleton variant="rect" height={518} />
              </div>
            )}
          </Card.Body>
        </Card>
      </>
    );
  } else
    return (
      <EditNewCampione
        campione={campioneForEdit}
        hideEditPage={() => {
          // setShowEditPage(false);
          push("#/");
        }}
        triggerServerUpdate={triggerServerUpdate}
      />
    );
};
